import React from 'react';

export default class DownArrow extends React.Component {
  render() {
    return (
      <svg width="16px" height="8px" viewBox="0 0 16 8" version="1.1">
          <defs></defs>
          <g id="Vehicle-Pass-Required" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g id="VEHICLE_PASS_REQ" transform="translate(-811.000000, -516.000000)" fill="#4E5F6B">
                  <g id="popup" transform="translate(335.000000, 458.000000)">
                      <g id="Username">
                          <polygon id="Shape-Copy" transform="translate(484.000000, 62.000000) scale(1, -1) translate(-484.000000, -62.000000) " points="476 66 484 58 492 66"></polygon>
                      </g>
                  </g>
              </g>
          </g>
      </svg>
    );
  }
}